import styled from 'styled-components';

const ErrorContainer = styled.div`
  padding: 15px 0;
`;

ErrorContainer.displayName = 'ErrorContainer';

export default ErrorContainer;
